module.exports = __webpack_public_path__ + "img/img03.4e865d61.png";